<template>
  <ServicePageLayout
    title="Admin"
    subtitle="บริหารจัดการ Tenant / Building / Service"
    icon="mdi-cog"
    breadcrumb="System"
  >
    <v-tabs v-model="tab" class="industrial-tabs">
      <v-tab>Tenants</v-tab>
      <v-tab>Buildings</v-tab>
      <v-tab>Services</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card flat class="service-content-panel">
          <v-card-text><AdminTenantTable ref="tenantTable" @refresh-tenants="loadTenants" /></v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat class="service-content-panel">
          <v-card-text><AdminBuildingTable ref="buildingTable" :tenants="tenants" /></v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat class="service-content-panel">
          <v-card-text>
            <AdminServiceTable ref="serviceTable" :tenants="tenants" :buildings="buildings" @tenant-selected="loadBuildings" />
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </ServicePageLayout>
</template>

<script>
import ServicePageLayout from '@/components/layout/ServicePageLayout.vue'
import AdminTenantTable from '@/components/admin/tenant_table.vue'
import AdminBuildingTable from '@/components/admin/building_table.vue'
import AdminServiceTable from '@/components/admin/service_table.vue'
import { getAdminTenants } from '@/api/'

export default {
  name: 'AdminView',
  components: {
    ServicePageLayout,
    AdminTenantTable,
    AdminBuildingTable,
    AdminServiceTable
  },
  data() {
    return {
      tab: 0,
      tenants: [],
      buildings: []
    }
  },
  mounted() {
    this.loadTenants()
  },
  methods: {
    async loadTenants() {
      try {
        const response = await getAdminTenants()
        this.tenants = response.data
      } catch (err) {
        console.log(err)
      }
    },
    async loadBuildings(tenantId) {
      try {
        const tenant = this.tenants.find(t => t.TenantId === tenantId)
        this.buildings = tenant ? tenant.Buildings : []
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>
